import Vue from 'vue'
import * as breakpoints from '@/js/global-breakpoints'

// Create vue component to update breakpoint and orientation on event changes
// using vue component reactivity
const reactorComponent = new Vue({
    data () {
        return {
            currentBreakpoint: null,
            currentOrientation: null,
            currentWidth: null
        }
    }
})

export default {
    computed: {
        $_globalMixin_currentBreakpoint () {
            return reactorComponent.currentBreakpoint
        },
        $_globalMixin_currentOrientation () {
            return reactorComponent.currentOrientation
        },
        $_globalMixin_currentWidth () {
            return reactorComponent.currentWidth
        },
        getActiveSlide () {
            return this.activeSlide
        },
        getItemsHovered () {
            return this.itemsHovered
        },
        getModalDisplayed () {
            return this.modalDisplayed
        },
        isDesktopBreakpoint () {
            return this.$_globalMixin_currentBreakpoint === breakpoints.BREAKPOINT_DESKTOP
        },
        isMobileBreakpoint () {
            return this.$_globalMixin_currentBreakpoint === breakpoints.BREAKPOINT_PHONE || this.$_globalMixin_currentBreakpoint === breakpoints.BREAKPOINT_TABLET
        },
        isPhoneBreakpoint () {
            return this.$_globalMixin_currentBreakpoint === breakpoints.BREAKPOINT_PHONE
        }
    },
    methods: {
        destroyTouchEvents () {
            this.slider.removeEventListener('touchstart', this.handleTouchStart, false)
            this.slider.removeEventListener('touchmove', this.handleTouchMove, false)
        },
        destroyWindowEvents () {
            window.removeEventListener('orientationchange', this.setPosition)
            window.removeEventListener('resize', this.setPosition)
        },
        getTouches (event) {
            return event.touches
        },
        handleTouchMove (event) {
            if (!this.xDown || !this.yDown) {
                return
            }

            const xUp = event.touches[0].clientX
            const yUp = event.touches[0].clientY

            const xDiff = this.xDown - xUp
            const yDiff = this.yDown - yUp

            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff > 0) {
                    this.nextSlide()
                } else {
                    this.previousSlide()
                }
            }
            // Reset values
            this.xDown = null
            this.yDown = null
        },
        handleTouchStart (event) {
            const firstTouch = this.getTouches(event)[0]
            this.xDown = firstTouch.clientX
            this.yDown = firstTouch.clientY
        },
        initActiveStep () {
            const queryStep = parseInt(this.$route.query.step)

            this.activeStep = queryStep && this.steps[queryStep - 2] && this.steps[queryStep - 2].validated ? queryStep - 1 : 0
        },
        initTouchEvents () {
            this.slider.addEventListener('touchstart', this.handleTouchStart, false)
            this.slider.addEventListener('touchmove', this.handleTouchMove, false)
        },
        initWindowEvents () {
            window.addEventListener('orientationchange', this.setPosition)
            window.addEventListener('resize', this.setPosition)
        },
        mediaQueries () {
            const updateCurrentBreakpoint = () => {
                const width = window.innerWidth
                reactorComponent.currentWidth = width

                if (width < breakpoints.BREAKPOINT_TABLET_WIDTH) {
                    reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_PHONE
                } else if (width < breakpoints.BREAKPOINT_DESKTOP_WIDTH) {
                    reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_TABLET
                } else {
                    reactorComponent.currentBreakpoint = breakpoints.BREAKPOINT_DESKTOP
                }
            }

            const updateCurrentOrientation = (angle) => {
                if (angle === 0) {
                    reactorComponent.currentOrientation = breakpoints.BREAKPOINT_PORTRAIT
                } else {
                    reactorComponent.currentOrientation = breakpoints.BREAKPOINT_LANDSCAPE
                }
            }

            window.addEventListener('resize', (event) => {
                updateCurrentBreakpoint()
                updateCurrentOrientation(event.target.screen.orientation.angle)
            })

            updateCurrentBreakpoint()
            updateCurrentOrientation(0)
        },
        nextStep () {
            this.steps[this.activeStep].validated = true
            this.activeStep++
        },
        scrollTop () {
            window.scrollTo(0, 0)
        },
        updateHovered (index, value) {
            this.$set(this.itemsHovered, index, value)
        }
    }
}
